import { getFormById, getForms } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormSelectors";
import {
    BaseFormHandlerParameter,
    FormModel,
    InputModel,
} from "@toolkit/Framework/Store/Toolkit/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";

export interface SetInputHandlerParameter extends BaseFormHandlerParameter {
    input: InputModel;
}

export interface SetInputHandlerProps {
    forms: FormModel[];
}

type HandlerType = Handler<SetInputHandlerParameter, SetInputHandlerProps>;

export const PopulateFormWithInputs: HandlerType = props => {
    const state = props.getState();
    const form = getFormById(state, props.parameter.formId);
    let forms = getForms(state);

    if (form) {
        forms = [...forms];
        const _form = cloneDeep(form);
        const index = findIndex(_form.inputs, x => x.id === props.parameter.input.id);

        if (index !== -1) {
            _form.inputs.splice(index, 1, props.parameter.input);
        } else {
            _form.inputs.splice(_form.inputs.length, 0, props.parameter.input);
        }

        const formIndex = findIndex(forms, x => x.id === _form.id);
        forms.splice(formIndex, 1, _form);
    }

    props.forms = forms;
};

export const DispatchSetInput: HandlerType = props => {
    props.dispatch({
        type: "Toolkit/Components/Form/SetInput",
        forms: props.forms,
    });
};

export const chain = [PopulateFormWithInputs, DispatchSetInput];

const setInput = createHandlerChainRunner(chain, "SetInput");

export default setInput;
